import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import {
  AppBar as MuiAppBar,
  Typography,
  Toolbar,
  IconButton,
  Box
} from "@mui/material";
import { Menu } from "@mui/icons-material";

import messages from "../../../assets/locale/messages";
import Logo from "../../../assets/images/vectors/Logo.svg";
import UserProfileButton from "../../UserDataDropDownBtn";
import NotificationsButton from "../../NotificationsBtn";
import { getDeviceId } from "../../../utils/Auth";
import { isUserForcedLogoutRequest } from "../../../store/Auth/actions";
import "./NavBar.scss";

const NavBar = ({
  drawerWidth,
  openMobileSideMenu,
  navbarHeight
}) => {
  const lang = useSelector((state) => state.locale.lang);
  const isAuth = useSelector((state) => state.auth.login?.Token);
  const id = useSelector((state) => state.auth.login?.Id);

  const { shared } = messages[lang];
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuth) {
      dispatch(
        isUserForcedLogoutRequest({
          device_id: getDeviceId(),
          navigate,
          params: {
            id,
            isEmployee: true
          }
        })
      );
    }
  }, [location]);

  const customStyle = {
    backgroundColor: "white",
    transition: (theme) =>
      theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen
      })
  };

  return (
    <MuiAppBar
      position="fixed"
      sx={{ ...customStyle, minHeight: navbarHeight }}
      className="nav-bar pe-xl-3 pe-md-0">
      <Toolbar>
        <div>
          <IconButton
            aria-label="open drawer"
            edge="start"
            onClick={() => openMobileSideMenu(true)}
            sx={{ color: "white", display: { md: "none" } }}
            className="mobile-toggle-icon">
            <Menu />
          </IconButton>
        </div>
        <div className="navbar-info-container w-100 d-flex justify-content-between align-items-center">
          <Box
            className="logo-container ps-md-3"
            sx={{
              width: `calc(${drawerWidth}px - 24px)`,
              display: {
                xs: "none",
                md: "block"
              }
            }}>
            <img src={Logo} alt="Logo" />
          </Box>
          <div className="navbarTitle-user-btns d-flex justify-content-between align-items-center ps-lg-5 ps-md-4 ps-2 w-100">
            <div className="navbarTitle">
              <Typography sx={{ flexGrow: 1, color: "white" }}>
                {shared.navbarTitle}
              </Typography>
            </div>

            <div className="navbar-btns-container d-flex justify-content-center gap-3 ">
              <NotificationsButton />
              <UserProfileButton />
            </div>
          </div>
        </div>
      </Toolbar>
    </MuiAppBar>
  );
};

NavBar.propTypes = {
  drawerWidth: PropTypes.number.isRequired,
  navbarHeight: PropTypes.number.isRequired,
  openMobileSideMenu: PropTypes.func.isRequired
};

export default NavBar;
